import * as React from "react"
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area"

import { cn } from "../lib/utils"

const ScrollArea = React.forwardRef(({ className, children, orientation = "both", ...props }, ref) => (
  <ScrollAreaPrimitive.Root
    ref={ref}
    data-slot="scroll-area"
    className={cn("relative overflow-hidden", className)}
    {...props}>
    <ScrollAreaPrimitive.Viewport className={cn("h-full w-full rounded-[inherit]", orientation === "vertical" && "overflow-x-hidden")}>
      {children}
    </ScrollAreaPrimitive.Viewport>
    {orientation !== "horizontal" && <ScrollBar orientation="vertical" />}
    {orientation !== "vertical" && <ScrollBar orientation="horizontal" />}
    <ScrollAreaPrimitive.Corner data-slot="scroll-area-corner" />
  </ScrollAreaPrimitive.Root>
))
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName

const ScrollBar = React.forwardRef(({ className, orientation = "vertical", ...props }, ref) => (
  <ScrollAreaPrimitive.Scrollbar
    ref={ref}
    orientation={orientation}
    data-slot="scroll-bar"
    className={cn(
      "flex touch-none select-none transition-colors",
      orientation === "vertical" &&
      "h-full w-[var(--ds-scrollbar-size)] border-l border-l-transparent p-[var(--ds-scrollbar-inset)]",
      orientation === "horizontal" &&
      "h-[var(--ds-scrollbar-size)] flex-col border-t border-t-transparent p-[var(--ds-scrollbar-inset)]",
      className
    )}
    {...props}>
    <ScrollAreaPrimitive.Thumb data-slot="scroll-thumb" className="relative flex-1 rounded-full bg-[var(--ds-scrollbar-thumb)] transition-colors hover:bg-[var(--ds-scrollbar-thumb-hover)]" />
  </ScrollAreaPrimitive.Scrollbar>
))
ScrollBar.displayName = ScrollAreaPrimitive.Scrollbar.displayName

export { ScrollArea, ScrollBar }
